var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"clearfix tag-pagination tag-pagination-{{$ctrl.layout}}\" ng-include=\"$ctrl.templateUrl()\"></div>";
var id1="tag-pagination.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;